import React from 'react';
import BaseMixin from './base-mixin.js';
import ElementaryMixin from './elementary-mixin.js';
import Tools from './tools.js';
import Environment from '../environment/environment.js'

//import './tag-placeholder.less';

export const TagPlaceholder = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Common.TagPlaceholder',
    classNames: {
      main: 'uu5-bricks-tag-placeholder'
    },
    opt: {
      url: 'https://uuos9.plus4u.net/uu-uu5componentregistryg01-main/85849867896916817-fe96c133c895434bbd4d5b24831483f3/getLibrary',
      cdnUrl: 'https://cdn.plus4u.net'
    },
    errors: {
      serverError: 'Unexpected error: %s.'
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    tagName: React.PropTypes.string,
    props: React.PropTypes.object,
    content: React.PropTypes.object,
  },
  //@@viewOff:propTypes
  //@@viewOn:getDefaultProps
  getDefaultProps() {
    return {
      tagName: null,
      props: null,
      content: null
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  getInitialState(){
    return {
      component: null
    }
  },

  componentDidMount(){
    this._findLib();
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _findLib(){
    let tagNameArr = this.props.tagName.split('.');
    let libraryName = tagNameArr[0] + '.' + tagNameArr[1];
    let dtoIn = {
      code: libraryName
    };

    let library = Environment.getLibrary(libraryName);
    library && library.version && (dtoIn.version = library.version);

    let url = this.getOpt('url');
    let query = Tools.encodeQuery(dtoIn);
    url += query;

    if (!Environment.tagCalls[query]) {
      Environment.tagCalls[query] = [
        (response) => {
          this._importLibrary(response, response.dependencies);
        }
      ];

      let request = new XMLHttpRequest();
      request.onreadystatechange = () => {
        if (request.readyState == XMLHttpRequest.DONE) {
          if (request.status == 200) {
            let response = JSON.parse(request.response);
            let tagCalls = Environment.tagCalls[query];
            delete Environment.tagCalls[query];
            tagCalls.forEach((fce) => fce(response));
          }
          else {
            this.showError('serverError', request.response, {
                component: this.getTagName(),
                searchedTag: this.props.tagName,
                library: library || libraryName
              }
            );
          }
        }
      };
      request.open('GET', url, true);
      request.setRequestHeader("Content-Type", "application/json");
      request.send(JSON.stringify(dtoIn));

    } else {
      Environment.tagCalls[query].push(
        (response) => {
          this._importLibrary(response, response.dependencies);
        });
    }


    return this;
  },

  _getSourceUrl(library) {
    let baseName = library.name.replace('_basic', '').replace('_forms');
    let sourceName = library.name.replace('uu_', '');
    return this.getOpt('cdnUrl') + '/' + baseName + '/' + library.version + '/' + sourceName + '.js';
  },

  _importLibrary(library, dependencies, setStateCallback) {
    let source = library.source;
    if (!source) {
      source = this._getSourceUrl(library);
    }

    if (window.System && window.System.import) {
      if (source) {
        System.config({
          map: dependencies
        });

        System.import(source).then(() => {
          let element = Tools.checkTag(this.props.tagName, false);
          this.setState({component: React.createElement(element, this.props.props, this.props.content)}, typeof setStateCallback === 'function' && setStateCallback);
        });
      } else {
        Tools.error('System was not found and has not set any source to import.', {
          source: source,
          tagName: this.props.tagName
        });
      }
    } else {
      Tools.error('System is not defined in window! Cannot import source:', {
        source: source,
        tagName: this.props.tagName
      });
    }
    return this;
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return this.state.component;
  }
  //@@viewOff:render
});

export default TagPlaceholder;



// WEBPACK FOOTER //
// ./common/tag-placeholder.js